import Model from 'src/app/core/models/model';

export default class PondUsageModel extends Model {
  id: string;
  name: string;
  code: string;
  isBH: number;
  description: string;
  createdAt: Date;
  updatedAt: Date;

  constructor() {
    super();
  }
}
